import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=f2320258&scoped=true&"
import script from "./Ai.vue?vue&type=script&lang=js&"
export * from "./Ai.vue?vue&type=script&lang=js&"
import style0 from "./Ai.vue?vue&type=style&index=0&id=f2320258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2320258",
  null
  
)

export default component.exports